import React from 'react';
import PropTypes from 'prop-types';
const uuid = require('uuid');
const map = require('lodash/map');
const Moment = require('moment');
import { withRouter } from 'react-router-dom';

import Navigator from '../../Navigator';

const GroupActions = require('../../actions/GroupActions');
const GroupStore = require('../../stores/GroupStore');
import TileListEmpty from '../tiles/TileListEmpty';
import AccessButton from '../common/AccessButton';
import SortableTableClassic from '../table/SortableTableClassic';
import SingleInputModal from '../modal/SingleInputModal2';
import ConfirmModal from '../modal/ConfirmModal';

const propTypes = {
    history: PropTypes.object.isRequired,
    className: PropTypes.string,
};
const defaultProps = {
    className: '',
};

class GroupListView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            deleteGroupID: null,
            deleteGroupActionId: null,
            createGroupActionId: null,
            showCreateGroupModal: false,
            groupStoreState: GroupStore.getState()
        };

        this.groupClickHandler = this.groupClickHandler.bind(this);
        this.groupDeleteHandler = this.groupDeleteHandler.bind(this);
        this.handleDeleteGroup = this.handleDeleteGroup.bind(this);
        this.createGroupHandler = this.createGroupHandler.bind(this);
        this.toggleCreateGroupModal = this.toggleCreateGroupModal.bind(this);
        this.handleCancelDeleteGroup = this.handleCancelDeleteGroup.bind(this);
        this.unsubscribes = [
            GroupStore.listen(this.onGroupStoreChange.bind(this))
        ];
    }

    UNSAFE_componentWillMount() {
        if (Object.keys(this.state.groupStoreState.groups).length === 0) {
            const actionId = uuid.v4();
            GroupActions.getGroups(actionId);
            // this.setState({ actionId: actionId }, () => {
                // GroupActions.getGroups(actionId);
            // });
        }
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onGroupStoreChange(state) {
        let additionalState = {};
        if (state.action.id === this.state.createGroupActionId) {
            if (!state.action.error) {
                additionalState = {
                    createGroupActionId: null,
                    showCreateGroupModal: false,
                };
            }
        }
        else if (state.action.id === this.state.deleteGroupActionId) {
            if (!state.action.error) {
                additionalState = {
                    deleteGroupActionId: null,
                    deleteGroupID: null,
                };
            }
            else {
                additionalState = {
                    deleteGroupActionId: null,
                    deleteGroupError: state.action.error,
                };
            }
        }

        this.setState({
            groupStoreState: state,
            ...additionalState,
        });
    }

    groupClickHandler(e, group_id, something) {
        Navigator.goToDashboardAuthorGroupView(this.props.history,group_id); //this.props.history.push('/group/' +  group_id);
    }

    groupDeleteHandler(rowKey, columnKey) {
        var group_id = rowKey;
        this.setState({ deleteGroupID: group_id });
    }

    handleDeleteGroup() {
        const deleteGroupActionId = uuid.v4();
        this.setState({ deleteGroupActionId: deleteGroupActionId }, () => {
            GroupActions.archiveGroup(deleteGroupActionId, { id: this.state.deleteGroupID });
        })
    }

    createGroupHandler(groupName) {
        const createGroupActionId = uuid.v4();
        this.setState({ createGroupActionId: createGroupActionId }, () => {
            GroupActions.createGroup(createGroupActionId, { name: groupName });
        });
    }

    toggleCreateGroupModal(showBool) {
        this.setState({ showCreateGroupModal: showBool });
    }

    handleCancelDeleteGroup() {
        this.setState({ deleteGroupID: '', deleteGroupError: null });
    }

    render () {
        const self = this;
        let elems =  [];
        if (this.state.groupStoreState) {
            if (this.state.groupStoreState.groups && (this.state.groupStoreState.groups.length > 0)) {
                const tableColumns = [
                    {displayName: 'Group',          key: 'name',            size: 3, type: 'string' },
                    {displayName: 'Create Date',    key: 'created_at',      size: 3, type: 'date',      sortKey: 'raw_date' },
                    {displayName: ' ',              key: 'deleteButton',    size: 1, type: 'iconButton' }, // custom cell type
                ];
                const tableRows = map(this.state.groupStoreState.groups, function(group) {
                    const date = new Moment(group.created_at);
                    const dateString = date.format("MMMM D YYYY");

                    return {
                        key: group.id,
                        name: group.name,
                        raw_date: group.created_at,
                        created_at: dateString,
                        deleteButton: {
                            className: 'group-delete-button fa fa-trash',
                            onClick: self.groupDeleteHandler.bind(self, group.id)
                        }
                    };
                });
                elems.push(
                    <div key="group_list" className="local-group-table">
                        <SortableTableClassic key="t-local-group"
                            title="Groups"
                            onRowClick={this.groupClickHandler}
                            rows={tableRows}
                            uniqueRowKey="key"
                            selectedRowKey={this.state.groupSelectedRowKey}
                            columns={tableColumns}
                        />
                    </div>
                );
            }
            else if (this.state.groupStoreState.loading) {
                elems.push( <TileListEmpty key="group_list" promptText="Loading..."/> );
            }

            elems.push(
                <AccessButton
                    key="group_add_button"
                    className="margin-top-lg"
                    onClick={this.toggleCreateGroupModal.bind(this, true)}
                    iconPath={`${GlobalConfig.StaticUrl}/img/Add_med.svg`}
                    iconStyle={{width:'35px'}}
                    text="New Group"
                />
            );
        }
        else {
            elems.push( <TileListEmpty promptText="Loading..."/> );
        }

        return (
            <div className={`group-list-view ${this.props.className}`}>
                {elems}
                {this.state.showCreateGroupModal &&
                    <SingleInputModal
                        show
                        action={this.state.groupStoreState.action}
                        childActionID={this.state.createGroupActionId}
                        headerText="Create Group"
                        inputLabel="group name"
                        ariaLabel="group name"
                        buttonText="create group"
                        closeHandler={this.toggleCreateGroupModal.bind(this, false)}
                        submitHandler={this.createGroupHandler}
                    />
                }
                {!!this.state.deleteGroupID &&
                    <ConfirmModal
                        show
                        modalTitle="Delete Group"
                        text="Are you sure you want to delete this group?"
                        buttonText="delete"
                        hasError={!!this.state.deleteGroupError}
                        message={!!this.state.deleteGroupError ? this.state.deleteGroupError.message : null}
                        closeHandler={this.handleCancelDeleteGroup}
                        confirmHandler={this.handleDeleteGroup}
                    />
                }
            </div>
        );
    }
}

GroupListView.propTypes = propTypes;
GroupListView.defaultProps = defaultProps;

export default withRouter(GroupListView);